import { Store, Common } from 'interfaces';

export default function updateError(state: Store.State, error?: Common.Error) {
  state.error = error;
}
